export function isSameDay(
  date1: Date | string | null | undefined,
  date2: Date | string | null | undefined,
): boolean {
  if (!date1 || !date2) {
    return false;
  }

  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Normalize to midnight
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);

  return d1.getTime() === d2.getTime();
}
